import { observer } from "mobx-react-lite";
import { useEffect, Fragment } from "react";
import "./index.css";
import {
  Button,
  Col,
  ConfigProvider,
  InputNumber,
  Dropdown,
  Form,
  Input,
  Menu,
  MenuProps,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import { CommonStore, TemplateManageStore } from "../../../store";
import dictionary from "../../../utils/dictionary";
import { DownOutlined, MoreOutlined } from "@ant-design/icons";
import Add from "./add";

function TemplateManage() {
  const [form] = Form.useForm();
  const { Column } = Table;
  const { Option } = Select;

  useEffect(() => {
    form.setFieldsValue({
      templateCode: "",
      templateId: "",
      templateSignatureNo: null,
      templateStatus: null,
      templateName: "",
    });
    resetSearchBth();
  }, []);
  const getFormData = (changeValue: any, allValues: any) => {
    console.log(changeValue, allValues);

    TemplateManageStore.setSearchForm({ ...allValues });
  };
  const resetSearchBth = () => {
    TemplateManageStore.setSearchForm({});
    searchBtn();
  };
  const searchBtn = () => {
    TemplateManageStore.resetPage();
    TemplateManageStore.getTemplatePage();
  };

  const moreOperations = (record: any) => {
    return [
      {
        label: "删除",
        key: "1",
      },
      {
        label:"禁用",
        key: "2",
        style: {
          color: record.templateStatus === 4 ? "red" : "",
          display:
            record.templateStatus === 4 
              ? ""
              : "none",
        },
      },
    ];
  };
  const moreOperationsClick = (e: any, record: any) => {
    if (e.key === "1") {
      return TemplateManageStore.deletePower(record.no);
    } else if (e.key === "2") {
      if (record.templateStatus === 4) {
        //去禁用
        return TemplateManageStore.toTemplateForbidden(record.no);
      } else if (record.templateStatus === 5) {
        //去启用
        return TemplateManageStore.toTemplateStart(record.no);
      }
    }
  };
  const items = [
    {
      label: "新增模版",
      key: "1",
    },
  ];
  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (e.key === "1") {
      return TemplateManageStore.addOrUpdateModal.open("add");
    }
  };
  return (
    <Fragment>
      <Add></Add>
      <div className="allContent">
        <div className="formContent">
          <Form
            form={form}
            initialValues={TemplateManageStore.searchForm}
            autoComplete="off"
            labelCol={{ span: 6 }}
            onValuesChange={getFormData}
            onKeyDown={(e) => {
              if (e.key.toLowerCase() === "enter") {
                searchBtn();
              }
            }}
          >
            <Row justify="start">
              <Col span={8}>
                <Form.Item label="模版编码" name="templateCode">
                  <Input placeholder="请输入模版编码" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="模版ID" name="templateId">
                  <Input placeholder="请输入模版ID" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="模版签名" name="templateSignatureNo">
                  <Select
                    allowClear={true}
                    placeholder="请选择模版签名"
                    showSearch
                    optionFilterProp="label"
                    options={
                      TemplateManageStore.getAllEnumList &&
                      TemplateManageStore.getAllEnumList.map((item: any) => ({
                        value: item.no,
                        label: item.templateSignature,
                      }))
                    }
                  ></Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="模版状态" name="templateStatus">
                  <Select placeholder="请选择模版状态">
                    {Object.keys(dictionary.templateStatus).map((key) => (
                      <Option key={key} value={key}>
                        {dictionary.templateStatus[key]}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="模版备注" name="templateName">
                  <Input placeholder="请输入模版备注" />
                </Form.Item>
              </Col>
              <Col offset={2}>
                <Form.Item>
                  <Space>
                    <Button type="primary" onClick={searchBtn}>
                      搜索
                    </Button>
                    <Button htmlType="reset" onClick={resetSearchBth}>
                      重置
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={8} offset={16}>
                {CommonStore.pagePermission.manageable && (
                  <Form.Item>
                    <Dropdown
                      menu={{ items }}
                      dropdownRender={(menu) => (
                        <Menu onClick={handleMenuClick} items={items} />
                      )}
                    >
                      <Button style={{ float: "right", marginRight: "10px" }}>
                        <Space>
                          变更
                          <DownOutlined />
                        </Space>
                      </Button>
                    </Dropdown>
                  </Form.Item>
                )}
              </Col>
            </Row>
          </Form>
        </div>
        <div>
          <ConfigProvider renderEmpty={CommonStore.tableEmptyRender}>
            <Table
              dataSource={TemplateManageStore.tableData.records}
              rowKey={(record) => record.no}
              loading={TemplateManageStore.tableLoad}
              scroll={{ x: 1300 }}
              pagination={{
                current: TemplateManageStore.pageData.page,
                pageSize: TemplateManageStore.pageData.size,
                onChange: TemplateManageStore.pageData.changePage,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
                total: TemplateManageStore.tableData.total,
                showTotal: () => `共计${TemplateManageStore.tableData.total}条`,
                position: ["bottomLeft"],
              }}
            >
              <Column
                fixed="left"
                ellipsis={true}
                width={150}
                title="模版编码"
                dataIndex="templateCode"
                render={(templateCode) => (
                  <Tooltip placement="topLeft" title={templateCode}>
                    {templateCode}
                  </Tooltip>
                )}
              />
              <Column
                ellipsis={true}
                width={150}
                title="模版ID"
                dataIndex="templateId"
                render={(templateId) => (
                  <Tooltip placement="topLeft" title={templateId}>
                    {templateId}
                  </Tooltip>
                )}
              />
              <Column
                ellipsis={true}
                width={150}
                title="模版备注"
                dataIndex="templateName"
              />
              <Column
                ellipsis={true}
                width={100}
                title="模版签名"
                dataIndex="templateSignatureNo"
                render={(templateSignatureNo) =>
                  TemplateManageStore.getAllEnumList.filter(
                    (item: any) => item.no == templateSignatureNo
                  )[0]?.templateSignature
                }
              />
              <Column
                title="模版状态"
                width={100}
                ellipsis={true}
                dataIndex="templateStatus"
                render={(templateStatus) =>
                  dictionary.templateStatus[templateStatus]
                }
              />
              <Column
                title="审核结果"
                width={120}
                dataIndex="templateAuditResult"
                ellipsis={true}
                render={(templateAuditResult) =>
                  dictionary.templateAuditResult[templateAuditResult]
                }
              />
              <Column
                title="审核意见"
                width={120}
                dataIndex="templateAuditMsg"
                ellipsis={true}
              />
              <Column
                title="有效日期"
                width={200}
                dataIndex="expirationDate"
                ellipsis={true}
                render={(expirationDate,record) =>
                  record.templateStatus === 4 && !expirationDate ? '永久': expirationDate
                }
              />
              <Column
                title="创建人"
                width={120}
                dataIndex="creator"
                ellipsis={true}
              />
              <Column
                title="创建时间"
                width={200}
                dataIndex="createTime"
                ellipsis={true}
              />
              <Column
                title="修改时间"
                width={200}
                dataIndex="updateTime"
                ellipsis={true}
              />
              <Column
                width={120}
                fixed={"right"}
                align={"right"}
                render={(text: string, record: any) => (
                  <Space>
                    {CommonStore.pagePermission.writable && record.templateStatus !== 5 && (
                      <Button
                        size={"small"}
                        onClick={() =>
                          TemplateManageStore.addOrUpdateModal.open(
                            "update",
                            record
                          )
                        }
                      >
                        编辑
                      </Button>
                    )}
                    {CommonStore.pagePermission.manageable && (
                      <Dropdown
                        dropdownRender={() => (
                          <Menu
                            onClick={(e) => moreOperationsClick(e, record)}
                            className={"menuSty"}
                            items={moreOperations(record)}
                          ></Menu>
                        )}
                      >
                        <Button size={"small"}>
                          <MoreOutlined />
                        </Button>
                      </Dropdown>
                    )}
                  </Space>
                )}
              />
            </Table>
          </ConfigProvider>
        </div>
      </div>
    </Fragment>
  );
}

export default observer(TemplateManage);
